
	import Vue from 'vue';
	import {Component, Emit, Prop, Watch} from 'vue-property-decorator';
	import SkinAutocomplete from "@/components/skin/SkinAutocomplete.vue";
	import SkinAvatar from "@/components/skin/SkinAvatar.vue";
	import {ISkin} from "@/models/ISkin";

	@Component({
		components: {SkinAvatar, SkinAutocomplete}
	})
	export default class SkinSetLabelDialog extends Vue {

		@Prop({type: Boolean, default: false})
		public open!: boolean;

		@Prop({type: Object, required: true})
		public skin!: ISkin;

		private loading: boolean = false;
		private label: string | null = null;

		private get valid(): boolean {
			return this.label !== null && this.label.trim().length > 0;
		}

		private reset(): void {
			this.label = this.skin.label;
		}

		private trySave(): void {
			if (!this.valid) return;
			this.loading = true;
			this.$store.dispatch('skin/setLabel', {id: this.skin.id, label: this.label})
				.then(() => this.save(this.label))
				.finally(() => this.loading = false);
		}

		@Watch('skin.label', {immediate: true})
		private onSkinLabelChanged(): void {
			this.reset();
		}

		@Watch('open')
		private onOpenChanged(value: boolean): void {
			if (!value) this.reset();
		}

		@Emit('cancel')
		public cancel(): void {
			//do nothing
		}

		@Emit('save')
		public save(label: string | null): string | null {
			return label;
		}

	}
